import { render, staticRenderFns } from "./notifyTab.vue?vue&type=template&id=7a384834&scoped=true&"
import script from "./notifyTab.vue?vue&type=script&lang=js&"
export * from "./notifyTab.vue?vue&type=script&lang=js&"
import style0 from "./notifyTab.vue?vue&type=style&index=0&id=7a384834&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a384834",
  null
  
)

export default component.exports